const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "LANGUAGES_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "LANGUAGES_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "LANGUAGES_SUCCESS":
			return {
				...state,
				languages: action.data.languages,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/languages.js